/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Have_AccountInputs */



/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Landing_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_have_account = /** @type {((inputs?: Landing_Have_AccountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Have_AccountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez déjà un compte ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Ya tiene una cuenta?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Já tem uma conta?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai già un account?")
	return /** @type {LocalizedString} */ ("Already have an account?")
});